import client from '@/apis/client';

export const createCategory = async (body) => {
  const { data } = await client.post('/categories', body);

  return data;
};

export const updateCategory = async (id, body) => {
  const { data } = await client.put(`/categories/${id}`, body);

  return data;
};

export const removeCategory = async (id) => {
  const { data } = await client.delete(`/categories/${id}`);

  return data;
};

export const getCategories = async (page, size) => {
  const params = {};

  if (page) {
    params.current_page = page;
  }

  if (size) {
    params.page_size = size;
  }

  const { data: { data: items, total } } = await client.get('/categories', { params });
  const offset = (page - 1) * size;
  const categories = items.map((item, index) => (
    {
      ...item,
      no: offset + (index + 1),
    }
  ));

  return { categories, total };
};

export const getCategory = async (distributionId) => {
  if (!distributionId) {
    return null;
  }

  const { data: { data } } = await client.get(`/categories/${distributionId}`);

  return data;
};
